import React from 'react';
import { View, Text, Linking } from 'react-native';
import { CompositeNavigationProp } from '@react-navigation/native';
import { t } from 'Locale';
import appManager, { logEvent } from 'AppManager';
// eslint-disable-next-line import/no-unresolved
import { Button, Hr } from 'LocalGluons';
import { Device } from 'DeviceUtils';

import defaultStyles from './QuickOnboardingInfoScene.jss';

interface QuickOnboardingInfoSceneProps {
    navigation: any; // TODO: FIX ME CompositeNavigationProp;
}

const QuickOnboardingInfoScene = ({
    navigation
}: QuickOnboardingInfoSceneProps): React.ReactElement => {
    const onRegisterPress = async () => {
        const data: { subscriptionPortalUrl: string } = await appManager.getMCoreConfigData();
        logEvent({ type: 'general', subtype: 'noaccount' });
        if (data?.subscriptionPortalUrl) {
            if (Device.isWeb) {
                window.open(data.subscriptionPortalUrl);
                return;
            }
            Linking.openURL(data.subscriptionPortalUrl).catch((err) => console.log('Error: QuickOnboardingInfoScene', err));
        }
    };

    return (
        <View style={defaultStyles.container}>
            <Text style={defaultStyles.title}>{t('ONBOARDING.TRIAL_TITLE_MOBILES')}</Text>
            <Hr style={defaultStyles.hrStyle} />
            <Text style={defaultStyles.subtitle}>{t('ONBOARDING.TRIAL_TEXT_MOBILES')}</Text>
            <Text style={defaultStyles.subtitle}>{t('ONBOARDING.BROWSER_INFO_TXT_MOBILES')}</Text>
            <View style={defaultStyles.buttonContainer}>
                <Button
                    style={{ button: defaultStyles.button }}
                    title={t('COMMON.SHOW_ME_THE_OFFER')}
                    onPress={onRegisterPress}
                />
                <Button
                    onPress={() => navigation.pop()}
                    style={{ button: defaultStyles.button }}
                    title={t('COMMON.CANCEL')}
                    isSecondary
                />
            </View>
        </View>
    );
};

export default QuickOnboardingInfoScene;
